export const newsSelector = state => state.newsfeed.news;
export const isFetchingSelector = state => state.newsfeed.isFetching;
export const unreadSelector = state => state.newsfeed.unread;
